import { Injectable } from '@angular/core';
import {  HttpGeneralService } from '../../shared/shared';
import { CONFIG } from '../../shared/config';

let hrUrl = CONFIG.baseUrls.hr;

export interface AlertApprovCycleTrans {
serial ?: number;
approveCycleSecLoginId ?: number;
alertConditionSerial ?: number;
requestSerial ?: number;
requestType ?:string;
status ?: number;
requestCycleSecLoginId ?: number;
empCode ?: number;
nameAr ?: string;
nameEn ?: string;
insideAlert ?: number;
mailAlert ?: number;
smsAlert ?: number;
whatsAppAlert ?: number;
mailAddress ?: string;
mobile ?: string;
refrenceType ?: number;
secLoginRefrence ?: number;
hrAlertApprovalCycleSerial ?: number ;
overridelowerlevel ?: number;
requestEmpCode ?: number;
decision?: number;
notes?: string;

}
 
@Injectable()
export class AlertApprovCycleTransService {
    constructor(private httpGeneralService: HttpGeneralService) { }

    getAlertApprovCycleTrans(id: number, requestType:string) {
        return this.httpGeneralService.getWith(`${hrUrl}/GetApproveCycleSecLoginData/${id}/${requestType}`);

    } 

    updateAlertApprovCycleTrans(alertApprovCycleTrans: AlertApprovCycleTrans) {
        return this.httpGeneralService.update<AlertApprovCycleTrans>(alertApprovCycleTrans.serial  ,alertApprovCycleTrans  ,`${hrUrl}/UpdateApproveCycleSecLoginData`);
    }

   
}
